import { Button, Textarea } from '@acpaas-ui/react-components';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReset } from '../../actions/fetch.actions';
import { resourceReset } from '../../actions/resources.actions';
import { fetchForTable, tableChange } from '../../actions/table.actions';
import { INPUT_STATES } from '../../components/forms/forms.utils';
import TextField from '../../components/forms/TextField';
import ResourceTable from '../../containers/core/ResourceTable';
import { usePreferences } from '../../hooks/usePreferences.hook';
import { DOSSIERS_RELATED_RESOURCE, DOSSIERS_RELATED_SEARCH_RESOURCE } from '../../resources/dossiers.related.resource';
import { currentUserSelector } from '../../selectors/auth.selectors';
import { fetchedSelector, fetchingSelector } from '../../selectors/fetch.selectors';
import { tableConfigSelector, tableSelectedSelector } from '../../selectors/resources.selectors';
import dossiersService from '../../services/api/dossiers.service';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const AddRelatedDossierModal = ({ isOpen, dossierId, onUpdated, onClose }) => {
  const dispatch = useDispatch();
  const user = useSelector(currentUserSelector);
  const resource = {
    ...DOSSIERS_RELATED_SEARCH_RESOURCE,
    table: { ...DOSSIERS_RELATED_SEARCH_RESOURCE.table, dataFilter: (item) => item.id !== dossierId }
  };
  const { sort, size } = usePreferences(user, resource);
  const isLoading = useSelector((state) => fetchingSelector(state, { resource }));
  const isLoaded = useSelector((state) => fetchedSelector(state, { resource }));
  const config = useSelector((state) => tableConfigSelector(state, { resource }));
  const selected = useSelector((state) => tableSelectedSelector(state, { resource }));

  const [error, setError] = useState('');
  const [query, setQuery] = useState('');
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setQuery('');
    setError('');
    setReason('');
    dispatch(resourceReset(resource));
    dispatch(fetchReset(resource));
    onClose();
  };

  const handleSearch = (e, buttonTrigger) => {
    if (!query) {
      return;
    }
    if (e?.code === 'Enter' || buttonTrigger) {
      dispatch(tableChange(resource, { ...config, dossierNumberRelated: query, searchForRelated: true }));
      dispatch(fetchForTable(resource, { sort, size }));
    }
  };

  const handleConfirm = () => {
    setIsSubmitting(true);
    dossiersService.relateDossiers(
      dossierId,
      { ids: selected, reason },
      {
        onError: (message) => {
          setError(message);
          setIsSubmitting(false);
        },
        onSuccess: () => {
          setIsSubmitting(false);
          handleClose();
          onUpdated();
        }
      }
    );
  };

  return (
    <Modal
      title={
        <ModalTitle
          hasError={!!error}
          title="Dossier linken"
          subtitle="Geef het dossiernummer in dat je wilt linken."
        />
      }
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      canConfirm={selected.length > 0}
      onConfirm={handleConfirm}
      onClose={handleClose}
      onConfirmLabel="Linken"
      onConfirmIcon="ai-check-1"
      width={1000}
    >
      <div className="row">
        <div className="col-xs-12 col-md-6 col-lg-4">
          <div className="u-flex">
            <div className="u-width-100 u-flex-1-1-auto">
              <TextField
                state={INPUT_STATES.DEFAULT}
                label="Dossiernummer"
                required
                value={query}
                onChange={setQuery}
                onKeyDown={handleSearch}
                disabled={isSubmitting}
              />
            </div>
            <Button
              icon="ai-search"
              className="u-flex-align-self-end u-flex-1-0-auto"
              onClick={() => handleSearch(null, true)}
              disabled={!query || isSubmitting}
            />
          </div>
        </div>
      </div>
      {(isLoading || isLoaded) && <ResourceTable resource={resource} />}
      {(isLoading || isLoaded) && (
        <div className="row">
          <div className="col-xs-12">
            <Textarea size="small" label="Reden" value={reason} onChange={(e) => setReason(e?.target?.value)} />
          </div>
        </div>
      )}
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
    </Modal>
  );
};

export default AddRelatedDossierModal;
